var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-book"},[_c('p',[_vm._v(" Add a new book using the form below. You can save your progress as a draft and continue editing later. Once you have completed and checked all the sections, please save and then submit for publishing. ")]),_c('BookForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }